import { Spinner } from '@alphonsocode/kallos';
import React, { useState } from 'react';

export default function Spinners({ count, color }) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10,
      }}
    >
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="spinner-grow spinner-grow-sm"
          role="status"
          style={{
            backgroundColor: color, //#a50234 - lg red, #157f95 - green or teal
            animationDelay: `${i * 0.1}s`,
            animationDuration: '1s',
          }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      ))}
    </div>
  );
}
